module.exports = __webpack_public_path__ + "img/iconCC-Social5.7a9eb860.png";